module.exports = __webpack_public_path__ + "img/DS-1440.04367b6c.jpg";